import axios from "axios";
import Config from "./Config";

const { API_BASE_URL } = Config;


// ---------------------------Category ------------------------
// =========================Get All Category=========================
export const getAllCategory = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/category`);
        if (response.data.status === true) {
            return response.data.responseData;
        } else {
            throw new Error(response.data.message || "API returned an error");
        }
    } catch (error) {
        console.error(
            "Error fetching admin data:",
            error.response || error.message || error
        );
        throw error;
    }
};
// =========================Get Product By Category=========================
export const getProductByCategory = async (Id, CountryId, StateId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/category-product`, {
            params: {
                CatId: Id,
                CountryId,
                StateId
            }
        });
        if (response.data.status === true) {
            return response.data;
        } else {
            throw new Error(response.data.message || "API returned an error");
        }
    } catch (error) {
        console.error(
            "Error fetching admin data:",
            error.response || error.message || error
        );
        throw error;
    }
};